module.exports = __webpack_public_path__ + "static/img/08.c1559fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/08.png
// module id = 7Bcr
// module chunks = 1